<template>
  <span
    class="bg-primary"
    style="border-radius: 1em; width: 24px; height: 24px; display: inline-flex"
  >
    <v-icon
      color="white"
      class="ma-auto"
      style="font-size: 12px"
      size="small"
      start
      >{{ lockState ? "$iconLock" : "$iconUnlock" }}</v-icon
    >
  </span>
</template>
<script>
export default {
  name: "AppShowLockState",
  props: {
    lockState: {
      type: Boolean,
      required: true
    }
  }
};
</script>
